import React from 'react';
import HairAnalysisScreen from '../screens/HairAnalysisScreen';

export default function HairAnalysisPage(): React.JSX.Element {
  return <HairAnalysisScreen mode="page" />;
}
